import React from "react";
import TrainCard from "literacy/assets/cards/trainpagecard";
import { Container, Button } from "@material-ui/core";

class MeaningTutorMain extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="jumbotron">
          <h2>Welcome to Meaning Session Tutor Main Page</h2>
          <br />
          <Button
            variant="contained"
            style={{ color: "white", backgroundColor: "#107896" }}
            href="/literacy"
          >
            Go back
          </Button>
        </div>
        <Container>
          <h3>Review Students' Assignments and Performance</h3>
          <div className="row">
            <TrainCard
              title="Students' Assignment"
              page="/literacy/tutor/meaning/assign"
              description="In this part, you can review students' testing assignment"
            />
            <TrainCard
              title="Students' Performance"
              page="/literacy/tutor/meaning/performance"
              description="In this part, you can check students' performance"
            />
          </div>
        </Container>
        <br />

        <Container>
          <h3>Modify Meaning Database</h3>
          <div className="row">
            <TrainCard
              title="Modify Learning Materials"
              page="/literacy/tutor/meaning/materials"
              description="In this part, you can modify learning materials"
            />
            <TrainCard
              title="Modify Meaning Blank Question Data"
              page="/literacy/tutor/meaning/blank"
              description="You can modify blank question data here"
            />
            <TrainCard
              title="Modify Meaning Multiple Choice Data"
              page="/literacy/tutor/meaning/multiple"
              description="You can modify Multiple Choice data here"
            />
            <TrainCard
              title="Modify Meaning True False data"
              page="/literacy/tutor/meaning/truefalse"
              description="In this part, you can modify true false question data"
            />
          </div>
        </Container>
      </div>
    );
  }
}

export default MeaningTutorMain;
